var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',{staticClass:"d-flex justify-space-around align-center pl-16"},[_c('Picture',{attrs:{"src":_vm.src,"max-width":"32","max-height":"32"}}),_c('span',{class:_vm.grayText,domProps:{"textContent":_vm._s(_vm.lc.faviconName)}}),_c('ModalDeleteFavicon',{on:{"onSuccess":function($event){return _vm.$emit('onSuccess')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }